import { z } from "zod";

export const searchSkillsQuerySchema = z
	.object({
		type: z.enum(["skill", "interest"]),
		search: z.string().optional(),
	})
	.strict();

export type SearchSkillsQueryPayload = z.infer<typeof searchSkillsQuerySchema>;
